import CIMSTable from 'components/CIMSTable'
import { useResponseDisciplinesTableContext } from '../../ResponseDisciplinesTableContext'
import { useColumns } from './hooks/useColumns'
import { useCreateOptions } from './hooks/useCreateOptions'
import { useEditOptions } from './hooks/useEditOptions'
import { useExpandOptions } from './hooks/useExpandOptions'
import { useRemoveOptions } from './hooks/useRemoveOptions'
import { useRestoreOptions } from './hooks/useRestoreOptions'

const ResponseDisciplinesTable: React.FC = () => {
  const { records, refetch, fetching } = useResponseDisciplinesTableContext()

  const columns = useColumns()
  const createOptions = useCreateOptions()
  const editOptions = useEditOptions()
  const removeOptions = useRemoveOptions()
  const restoreOptions = useRestoreOptions()
  const expand = useExpandOptions()

  return (
    <CIMSTable
      rowKey={'id'}
      loading={fetching}
      records={records}
      columns={columns}
      actions={{
        header: {
          create: createOptions,
          onReload: refetch,
        },
        row: {
          edit: editOptions,
          remove: removeOptions,
          restore: restoreOptions,
        },
      }}
      expand={expand}
    />
  )
}

export default ResponseDisciplinesTable
